(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function PdpSocialProofCarousel(root) {
    var slides  = Array.prototype.slice.call(root.querySelectorAll('.pspc__slide'));
    var dots    = Array.prototype.slice.call(root.querySelectorAll('.pspc__dot'));
    var prevBtn = root.querySelector('.pspc__arrow--prev');
    var nextBtn = root.querySelector('.pspc__arrow--next');
    var total   = slides.length;

    if (total < 2) return;

    var current    = 0;
    var timer      = null;
    var doAutoplay = root.dataset.pspcAutoplay === 'true';
    var interval   = parseInt(root.dataset.pspcInterval, 10) || 6000;

    function goTo(n) {
      var next = ((n % total) + total) % total;

      slides[current].classList.remove('pspc__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) {
        dots[current].classList.remove('pspc__dot--active');
        dots[current].setAttribute('aria-pressed', 'false');
      }

      current = next;

      slides[current].classList.add('pspc__slide--active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) {
        dots[current].classList.add('pspc__dot--active');
        dots[current].setAttribute('aria-pressed', 'true');
      }
    }

    /* Always clear any existing timer before starting a new one.
       This prevents duplicate intervals when startTimer() is called
       from multiple sources (click handlers + mouseleave + focusout). */
    function startTimer() {
      if (!doAutoplay || prefersReducedMotion) return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    function stopTimer() {
      clearInterval(timer);
      timer = null;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        stopTimer();
        goTo(current - 1);
        startTimer();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        stopTimer();
        goTo(current + 1);
        startTimer();
      });
    }

    for (var d = 0; d < dots.length; d++) {
      (function (idx) {
        dots[idx].addEventListener('click', function () {
          stopTimer();
          goTo(idx);
          startTimer();
        });
      })(d);
    }

    root.addEventListener('mouseenter', stopTimer);
    root.addEventListener('focusin',    stopTimer);

    root.addEventListener('mouseleave', function () {
      if (doAutoplay) startTimer();
    });

    root.addEventListener('focusout', function (e) {
      if (doAutoplay && !root.contains(e.relatedTarget)) startTimer();
    });

    /* Touch / swipe support ————————————————————————————————
       Swipe left = next, swipe right = prev.
       Only triggers when horizontal movement > vertical movement
       AND exceeds 40 px, so normal page scrolling is unaffected.
       Attached to .pspc__card so arrows/dots are never the source. */
    var swipeEl = root.querySelector('.pspc__card') || root;
    var swipeX  = 0;
    var swipeY  = 0;

    swipeEl.addEventListener('touchstart', function (e) {
      swipeX = e.changedTouches[0].clientX;
      swipeY = e.changedTouches[0].clientY;
    }, { passive: true });

    swipeEl.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - swipeX;
      var dy = e.changedTouches[0].clientY - swipeY;
      if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
      stopTimer();
      goTo(dx < 0 ? current + 1 : current - 1);
      startTimer();
    }, { passive: true });

    startTimer();
  }

  function init() {
    var roots = document.querySelectorAll('[data-pspc-root]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (!root.dataset.pspcInit) {
        root.dataset.pspcInit = '1';
        new PdpSocialProofCarousel(root);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-initialise after Shopify theme editor section reloads */
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
